import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/dot-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 56c-110.5 0-200 89.5-200 200 0 110.5 89.5 200 200 200 110.5 0 200-89.5 200-200 0-110.5-89.5-200-200-200zM256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM256 176c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z'
      }
    ]
  }
})
